export default __webpack_public_path__ + "locales/fi/VersionHistory.json?hash=a96fbdfe80311185fc5cc6c64f80bbbd";